var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Logo from '../../../Logo';
const LogoApple = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M20.0165 4.49714C20.9831 3.28653 21.6391 1.66105 21.4661 0C20.0511 0.0704511 18.3244 0.934734 17.3248 2.14629C16.4272 3.18379 15.6327 4.87734 15.8398 6.46876C17.4282 6.60672 19.0151 5.67377 20.0165 4.49714Z", fill: "#192325" }),
            React.createElement("path", { d: "M21.4481 6.77954C19.1414 6.64196 17.1801 8.09043 16.0786 8.09043C14.9764 8.09043 13.2896 6.84887 11.4651 6.88234C9.09046 6.91726 6.88705 8.26169 5.68202 10.4C3.20346 14.6776 5.02793 21.0227 7.43819 24.5066C8.60867 26.2302 10.0193 28.128 11.878 28.0598C13.6342 27.9908 14.3225 26.9211 16.4572 26.9211C18.5904 26.9211 19.2104 28.0598 21.0694 28.0253C22.9973 27.9908 24.2025 26.3009 25.373 24.5756C26.7158 22.6108 27.2654 20.7137 27.3 20.6095C27.2654 20.575 23.5826 19.1603 23.5484 14.9183C23.5137 11.3663 26.4399 9.67684 26.5776 9.57206C24.9251 7.12481 22.3432 6.84887 21.4481 6.77954Z", fill: "#192325" }))),
        alt: 'Apple sign in',
    };
    return React.createElement(Logo, Object.assign({}, commonProps, { source: source }));
};
export default LogoApple;
//# sourceMappingURL=index.js.map